<script lang="ts">
    import { faPlusCircle, faEdit } from '@fortawesome/free-solid-svg-icons'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { onMount } from 'svelte'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import dayjs from 'dayjs'
    import DateSelect from '../_common/date-select.svelte'
    import Helper from '../_common/helper.svelte'
    import Popover from '../_common/popover.svelte'
    import { ProductInvoicesRepository } from '../../modules/posApi/stock/product-invoices/product-invoices.repository'
    import { ProductInvoicesService } from '../../modules/posApi/stock/product-invoices/product-invoices.service'
    import StockInForm from './stock-in-form.svelte'
    import type { ProductInvoice } from '../../modules/posApi/stock/product-invoices/product-invoice'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'

    const rep = new ProductInvoicesRepository()
    const service = new ProductInvoicesService(rep)

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)

    let show = false
    let entities: ProductInvoice[] = []
    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    let dateSelect
    let selectedPerson: Person = null

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            const filter = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                personId: selectedPerson ? selectedPerson.personId : undefined,
            }

            // limita a navegação por mais de 7 dias
            // if (!window.store.token.permissions.pos.sales.navigate) {
            //     const diff = dayjs(new Date()).diff(filter.from, 'days')
            //     if (diff > 7) {
            //         dates.from = dayjs(new Date()).add(-7, 'day').toDate()
            //         filter.from = dates.from
            //         dateSelect.setDate(dates.from, dates.to)
            //     }
            // }

            entities = await service.getAll(filter)
            let persons: Person[] = []
            let personsId = []
            for (const invoice of entities) {
                personsId.push(invoice.personId)
            }

            let promises = []
            for (let i = 0; i < personsId.length; i += 100) {
                const chunk = personsId.slice(i, i + 100)
                promises.push(personsS.getAll({ persons: chunk.join(',') }))
            }
            const results = await Promise.all(promises)
            for (const result of results) {
                persons = persons.concat(result)
            }
            for (let invoice of entities) {
                invoice.person = persons.find((el) => el.personId === invoice.personId)
            }

            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showActs = true
        grid.title = 'Entradas realizadas'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Data do lançamento', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Data da entrada', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Fornecedor' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.acquiredAt })
            line.slots.push({ content: item.person?.name })
            line.slots.push({
                content: [
                    new GridButton({
                        label: 'Editar',
                        icon: faEdit,
                        callback: () => {
                            editEntity(item.productInvoiceId)
                        },
                    }),
                ],
            })
            grid.lines.push(line)
        }
        grid = grid
    }

    function evaluateError(error) {
        window.error(error)
    }

    async function dateChanged(event) {
        dates = event.detail
        await loadEntities()
    }

    function showPerson(personId) {
        window.person('show', personId)
    }

    let showForm = false
    let productInvoiceId: string = null
    function editEntity(id) {
        productInvoiceId = id
        showForm = true
    }
    function newEntity() {
        productInvoiceId = null
        showForm = true
    }
    function formChanged() {
        loadEntities()
        showForm = false
    }
    function formCanceled() {
        showForm = false
    }

    function selectedPersonChanged() {
        loadEntities()
    }
</script>

{#if showForm}
    <Popover
        title="Entrada de Produtos/Insumos"
        width="1300px"
        height="90vh"
        on:close={() => {
            showForm = false
        }}
    >
        <StockInForm {productInvoiceId} on:change={formChanged} on:cancel={formCanceled} />
    </Popover>
{/if}

<Content footer={true}>
    <Zact>
        <div>
            <ZentitySelect fonte="pessoa" label="Fornecedor" bind:value={selectedPerson} on:change={selectedPersonChanged} />
        </div>
        <DateSelect bind:this={dateSelect} startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
        <div class="spacer"></div>
        {#if window.store.token.permissions.stock.inputs.write}
            <Zbutton color="primary" icon={faPlusCircle} label="Nova entrada" mobileHideLabel={true} on:click={newEntity} />
        {/if}
    </Zact>
    <Zgrid class="h-space" {grid}></Zgrid>
    <LoadSpinner {show} />
</Content>

<style>
</style>
